import img1 from '../assets/images/project-1.jpg';
import img2 from '../assets/images/project-2.jpg';
import img3 from '../assets/images/project-3.jpg';
import img4 from '../assets/images/project-4.jpg';
import img5 from '../assets/images/project-5.jpg';
import img6 from '../assets/images/project-6.png';

export const projectList = [
    {
        name: "Calculadora React",
        id: "01",
        src: img1,
        repositoryURL: "https://github.com/Anselmo1122/Calculadora-React",
        demoURL: "https://calculadora-react-adh.netlify.app",
    },
    {
        name: "Mis Tareas",
        id: "02",
        src: img2,
        repositoryURL: "https://github.com/Anselmo1122/Aplicacion-de-Tareas-React",
        demoURL: "https://tareas-react-adh.netlify.app",
    },
    {
        name: "Error page",
        id: "03",
        src: img4,
        repositoryURL: "https://github.com/Anselmo1122/Challenge-404-not-found",
        demoURL: "https://devchallenges-notfound-adh.netlify.app",
    },
    {
        name: "Checkout page",
        id: "04",
        src: img5,
        repositoryURL: "https://github.com/Anselmo1122/Challenge-Checkout-page",
        demoURL: "https://devchallenges-checkoutpage-adh.netlify.app",
    },
    {
        name: "New Year's Purposes",
        id: "05",
        src: img3,
        repositoryURL: "https://github.com/Anselmo1122/OB-New-year-purposes",
        demoURL: "https://new-year-purposes-adh.netlify.app/"
    },
    {
        name: "Paint canva",
        id: "06",
        src: img5,
        repositoryURL: "https://github.com/Anselmo1122/Paint-Canva",
        demoURL: "https://paint-canva-adh.netlify.app",
    },
    {
        name: "Edie Homepage",
        id: "07",
        src: img6,
        repositoryURL: "https://github.com/Anselmo1122/Challenge-Edie-home-page",
        demoURL: "https://devchallenges-ediehomepage-adh.netlify.app/",
    }
]